import React, { Component } from "react";
import { db } from "./services/firebase";
import Cookies from 'universal-cookie';
import iconSendMsg from "./images/send-icon.png";
import iconBack from "./images/icon-left-arrow.png";
import iconUserTyping from "./images/icon-user-typing.svg";
import MsgViewed from "./components/MsgViewed";
import Locale, { formatTime } from "./components/Locale";

export default class Chat extends Component{
  constructor(props){
    super(props);
    this.cookies = new Cookies();
    this.state = {
      name: false,
      messages: false,
      supportID: this.cookies.get('supportID'),
      typing: false,
      content: ''
    }
    this.myRef = React.createRef();
    this.db_Chats = db.ref('chats');
    this.db_Messages = db.ref('messages');
    this.language = window.location.pathname.replace('/', '');
    this.language = (this.language === '')?'en':this.language;
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }

  componentDidMount(){
    this.setListeners();
  }

  render() {
    return (
      <div id="chat"> 
        <header>
            <span className="back"><a href="/"><img src={iconBack} alt="<" width="20" height="20" /></a></span>
            <span className="title">{Locale.admin}</span>
        </header>
          
          <div className="messages" ref={this.myRef}>
          {
            (!this.state.messages)?'loading...':this.state.messages.map((message, i) => {
              const viewed = (message.from === 'user' ? <MsgViewed viewed={message.viewed} /> : '');
              return (
                <div key={i} className={message.from === 'user' ? 'message current' : 'message'}>
                  <div>
                    <div dangerouslySetInnerHTML={{__html: message.content.replace(/\n/g, '<br>')}} />
                    <div className="information">
                      {formatTime(message.timestamp)}
                      {viewed}
                    </div>
                  </div>
                </div>     
              )
            })
          }
          {this.state.typing ? <p className="usertyping"><img src={iconUserTyping} alt='typing' width='32' /></p>: ''}
          </div>

          <div className="send-form" style={{position: this.state.headerPosition}}>
            <textarea
              className="message"
              dir="ltr"
              onChange={this.handleChange}
              onBlur={this.handleBlur}
              value={this.state.content}
            />
            <img className="btn-send" onClick={this.handleSubmit} src={iconSendMsg} alt="Send" width="45" />
          </div>
      </div>
    );
  }

  setListeners(){
    const supportID = this.state.supportID;
    const chatArea = this.myRef.current;
    // messages listener
    this.db_Messages.child(supportID).on('value', snapshot => {
      let messages = [];
      let viewedNodes = [];
      snapshot.forEach((snap) => {
        if(snap.val().from === 'admin' && snap.val().viewed === false){
          viewedNodes.push(snap.key);
        }
        const message = snap.val();
        messages.push(message);
      });
      messages.sort(function (a, b) { return a.timestamp - b.timestamp })
      this.setState({ messages });
      this.updateViewedNodes(viewedNodes);
      chatArea.scrollBy(0, chatArea.scrollHeight);
    });
    // user typing
    this.db_Chats.child(supportID).child('typing').child('admin').on("value", snapshot => {
      const typing = snapshot.val();
      this.setState({ typing });
      if(typing){chatArea.scrollBy(0, chatArea.scrollHeight);}
    });
  }


  async handleSubmit(){
    const supportID = this.state.supportID;
    const timestamp = Date.now();
    if(this.state.content !== '' && supportID !== ''){
      const chatArea = this.myRef.current;
      this.db_Messages.child(supportID).push({
        content: this.state.content,
        timestamp,
        from: 'user',
        viewed: false
      })
      .then((snap) => {
        this.db_Chats.child(supportID).update({
          timestamp,
          unread: true
        });
        this.setState({content: ''});
        chatArea.scrollBy(0, chatArea.scrollHeight);
      })
      .catch(error => {
        this.setState({error: error.code});
      });
    }
  }

  handleChange(event){
    const supportID = this.state.supportID;   
    this.db_Chats.child(supportID).child('typing').update({user: true})
    this.setState({content: event.target.value});
  }

  handleBlur(event){
    const supportID = this.state.supportID;   
    this.db_Chats.child(supportID).child('typing').update({user: false})
  }

  updateViewedNodes(nodes){
    const supportID = this.state.supportID;
    const updateNodes = {};
    nodes.forEach(node => {
      updateNodes[node+'/viewed'] = true;
    });
    try{
      this.db_Messages.child(supportID).update(updateNodes);
    }catch(error){
      console.log(error);
    }
  }
}
